
import "./MeetTheTeams.scss"
import React from 'react'

import TabView from '../../../../components/prime-react-overrides/tab-view/TabView'
import { teamsContent } from '../../SopsData'
import { ReactComponent as TeamsProcess } from '../../assets/knowledgeTeam.svg'
import { useEffect } from 'react'


function MeetTheTeams() {
  const team = teamsContent.map((ele, index) => {
    return { label: ele.title, component: <MeetTeamContent title={ele.title} mail={ele.mail} content={ele.content} index={index} /> }

  })

  return (
    <div >
      <div className="flex w-full justify-content-center mb-2 align-content-center">
      <span className="text-xl font-bold">Meet the teams</span>
      </div>

      <TabView data={team} >
      </TabView>


    </div>
  )
}

export default MeetTheTeams


function MeetTeamContent({ title, mail, content, index }) {

  return (

    <div>


      <div className="flex align-items-center MeetTheTeams  ">

        <p className="underline font-medium mail ">{mail}</p>
      </div>
      <div className="line-height-4 font-medium flex ">
        <div >{content.map((text, contentIndex) =>
          <div className={`${contentIndex > 0 && "mt-3 "} ${index == 0 && "mr-3 "}`}>
            {text}
          </div>)}</div>
        <div>{index == 0 && <TeamsProcess />}</div>
      </div>



    </div>



  )

}